// extracted by mini-css-extract-plugin
export default {"banner":"info-banner_banner__+ZU1c","bannerHeader":"info-banner_bannerHeader__Z0XQ0"};